{
  "valid": "Gyldig"
}
